import header from '@/components/header';
import footer from '@/components/footer';
import intersectionLoader from '@/utils/loaders/intersection';
import onEvent from '@/utils/loaders/on-event';
import onElementInteraction from '@/utils/loaders/on-element-interaction';
import giftWithPurchase from '@/components/gift-with-purchase'

export default (app) => {
  app.add({
    header,
    footer,

    cartValidation: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-cart-validation" */ '@/components/cart-validation'),
    ],
    cartDrawer: [
      [onEvent, onElementInteraction],
      () => import(/* webpackChunkName: "component-cart-drawer" */ '@/components/cart-drawer'),
    ],
    cartDrawerItem: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-cart-drawer-item" */ '@/components/cart-drawer-item'),
    ],
    cartDrawerPresent: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-cart-drawer-present" */ '@/components/cart-drawer-present'),
    ],
    cartRedirect: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-cart-redirect" */ '@/components/cart-redirect'),
    ],
    giftWithPurchase,
    headerSearch: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-header-search" */ '@/components/header-search'),
    ],
    mobileSearch: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-mobile-search" */ '@/components/mobile-search'),
    ],
    languageSwitch: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-language-switch" */ '@/components/language-switch'),
    ],
    pageTemplate: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-page-template" */ '@/components/page-template'),
    ],
    productRecommendations: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-recommendations" */ '@/components/product-recommendations'),
    ],
    productCarousel: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-carousel" */ '@/components/product-carousel'),
    ],
    recommendedProducts: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-recommended-products" */ '@/components/recommended-products'),
    ],
    articleShopTheLook: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-article-shop-the-look" */ '@/components/article-shop-the-look'),
    ],
    articleShopTheLookItem: [
      intersectionLoader,
      () =>
        import(
          /* webpackChunkName: "component-article-shop-the-look-item" */ '@/components/article-shop-the-look-item'
        ),
    ],
    customerAddressForm: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-customer-address-form" */ '@/components/customer-address-form'),
    ],
    customerAddresses: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-customer-addresses" */ '@/components/customer-addresses'),
    ],
    customerLogin: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-customer-login" */ '@/components/customer-login'),
    ],
    customerAccount: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-customer-account" */ '@/components/customer-account'),
    ],
    searchTemplate: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-search-template" */ '@/components/search-template'),
    ],
    pageContactFaq: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-page-contact-faq" */ '@/components/page-contact-faq'),
    ],
    pageContactInfo: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-page-contact-info" */ '@/components/page-contact-info'),
    ],
    googleMaps: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-google-maps" */ '@/components/google-maps'),
    ],
    clerkProductSlider: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-clerk-product-slider" */ '@/components/clerk-product-slider'),
    ],
    heroVideo: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-hero-video" */ '@/components/hero-video'),
    ],

    // Page-specific components (previously in separate entries)
    blog: [intersectionLoader, () => import(/* webpackChunkName: "component-blog" */ '@/pages/blog/main')],
    product: [intersectionLoader, () => import(/* webpackChunkName: "component-product" */ '@/pages/product/product')],
    productColors: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-colors" */ '@/pages/product/product-colors'),
    ],
    productTabs: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-tabs" */ '@/pages/product/product-tabs'),
    ],
    productImages: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-images" */ '@/pages/product/product-images'),
    ],
    collection: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-collection" */ '@/pages/collection/main'),
    ],
    collectionFilter: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-collection-filter" */ '@/pages/collection/filter'),
    ],
    collectionProtection: [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-collection-protection" */ '@/pages/collection/collection-protection'),
    ],
    collectionSeoText: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-collection-seo-text" */ '@/pages/collection/collection-seo-text'),
    ],
    filterSlidein: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-filter-slidein" */ '@/pages/collection/filterSlidein'),
    ],
    autoplay: [intersectionLoader, () => import(/* webpackChunkName: "component-autoplay" */ '@/components/autoplay')],
    video: [intersectionLoader, () => import(/* webpackChunkName: "component-video" */ '@/components/video')],
  })
};
